import React, { Component } from 'react';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

export default class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.resetPassword = this.resetPassword.bind(this);
    this.checkPasswordMatchesConfirmation = this.checkPasswordMatchesConfirmation.bind(this);
  }

  state = { valid: false };

  resetPassword(event) {
    event.preventDefault();
    const params = {
      email: this.props.location.query.email,
      password: this.password.value,
      password_confirmation: this.password_confirmation.value,
      passwordResetToken: this.props.location.query.token,
    };
    $.post(`${config.localeApi}/resetpassword`, params)
      .done((response) => {
        toastr.success(
          response.data, '',
          { positionClass: 'toast-bottom-full-width' },
        );
      })
      .fail((response) => {
        const errors = response.responseJSON.errors;
        const responseMsg = this.buildErrorMessage(errors);
        toastr.error(responseMsg, '', { positionClass: 'toast-bottom-full-width' });
      });
  }

  buildErrorMessage(errors) {
    if (typeof errors === 'string') {
      return errors;
    }
    let errorStr = '';
    const keys = Object.keys(errors);
    keys.forEach(key => errors[key].forEach(msg => errorStr += `${msg}<br/>`));
    return errorStr;
  }

  checkPasswordMatchesConfirmation() {
    if (this.password.value.length !== 0 &&
      (this.password.value === this.password_confirmation.value)) {
      this.setState({ valid: true });
    } else {
      this.setState({ valid: false });
    }
  }

  render() {
    const { valid = false } = this.state;
    return (
      <form id="reset-form" className="container py-5 col-md-6" method="post" onSubmit={this.resetPassword}>
        <div>
          <h2 className="text-center"><HTMLTrans id='navbar.auth_resetpassword_title'>Reset Password</HTMLTrans></h2>
        </div>
        <div className="form-group mt-3">
          <label htmlFor="reset-password-password"><HTMLTrans id='navbar.auth_resetpassword_new_password_label'>Your new password</HTMLTrans></label>
          <input type="password" id="reset-password-password" className="form-control mb-3"
                 ref={input => this.password = input}
                 onChange={this.checkPasswordMatchesConfirmation}></input>
          <label htmlFor="reset-password-password-confirmation"><HTMLTrans id='navbar.auth_resetpassword_retype_password_label'>Retype password</HTMLTrans></label>
          <input type="password" id="reset-password-password-confirmation" className="form-control"
                 ref={input => this.password_confirmation = input}
                 onChange={this.checkPasswordMatchesConfirmation}></input>
          <div className="text-center mt-3">
            <button disabled={!valid} id="reset-password-submit"
                    className='btn btn-lg btn-secondary'
                    type="submit" value="Submit"><HTMLTrans id='navbar.auth_resetpassword_submit_button'>Submit</HTMLTrans>
            </button>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Auth/ResetPassword.js